import { create } from 'zustand';

function getCurrentHash() {

    try {
        return localStorage.getItem('currentHash') ?? 'viagens-do-dia';
    } catch {
        return '';
    }

}

function saveCurrentHash(hash) {

    try {
        localStorage.setItem('currentHash', hash);
    } catch {}

}

export const useCurrentHashStore = create((set) => ({

    currentHash: getCurrentHash(),

    setCurrentHash: (currentHash) => {

        saveCurrentHash(currentHash);

        set({ currentHash });

    }

}));